import { h } from 'preact';
import style from './style';
import { Text } from 'preact-i18n';
import { formatLastTradeTime } from '../../lib/util';

export default function LastUpdated({ LastTradeTime, currency }) {
	return (
		<div class={style.lastUpdated}>

			{
				LastTradeTime && <Text id="lastUpdated" fields={{ lastUpdateTime: formatLastTradeTime(LastTradeTime) }} />
			}

			{ currency && <Text id="currency" fields={{ currency }} /> }<Text id="quotesDelayed" />
			<a class={style.disclaimer} href="/finance/disclaimer" target="_blank" rel="noopener noreferrer">
				<Text id="disclaimer" />
			</a>

			<div class={style.poweredBy}>
				<Text id="poweredBy" />
				<a href="//www.cloudquote.net" target="_blank" rel="noopener noreferrer">
					<Text id="poweredByProvider" />
				</a>
			</div>

		</div>
	);
}



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-blocks/src/components/last-updated/index.js